var render = function render(){
  var _vm$order_saving_erro, _vm$order_saving_erro2, _vm$order_saving_erro3, _vm$activeDeliverySit;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    staticClass: "enterprise-split-modal-shell",
    attrs: {
      "help-content-id": "popup-order-".concat(_vm.current_entity_profile),
      "flat-chrome": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('template', {
    slot: "rawcontent"
  }, [_c('div', {
    staticClass: "enterprise-split-modal enterprise-split-modal--stitch general-settings-reference"
  }, [_c('div', {
    staticClass: "enterprise-split-modal__body d-flex flex-column flex-md-row flex-grow-1 flex-shrink-1 min-height-0"
  }, [_c('section', {
    staticClass: "enterprise-split-modal__form order-edit-column d-flex flex-column"
  }, [_c('div', {
    staticClass: "stitch-modal stitch-modal--split"
  }, [_c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-cart-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("orderSection")))])], 1), _c('div', {
    staticClass: "stitch-modal__stack"
  }, [_c('DateTime', {
    attrs: {
      "value": _vm.order.order_date,
      "label": _vm.$translate('orderDateLabel'),
      "error-messages": (_vm$order_saving_erro = _vm.order_saving_errors) === null || _vm$order_saving_erro === void 0 ? void 0 : _vm$order_saving_erro.order_date,
      "only-date": true,
      "dense": "",
      "outlined": "",
      "min-date": null,
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.updateOrderDate($event);
      }
    }
  }), _c('div', [_c('SearchCustomer', {
    key: _vm.buyer_id,
    attrs: {
      "value": _vm.buyer_id,
      "error-messages": (_vm$order_saving_erro2 = _vm.order_saving_errors) === null || _vm$order_saving_erro2 === void 0 ? void 0 : _vm$order_saving_erro2.customer,
      "allow-create": true,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.setBuyerAction($event);
      }
    }
  }), _vm.buyer_id && _vm.buyer_id !== 'new' && _vm.overdue_invoices_stats && _vm.overdue_invoices_stats.invoices > 0 && _vm.userHasPermission('billing.view_invoice') ? _c('v-alert', {
    staticClass: "mt-4",
    attrs: {
      "type": "warning",
      "dense": "",
      "text": ""
    }
  }, [_c('small', [_vm._v(" " + _vm._s(_vm.overdueUnpaidInvoicesMessage) + " "), _c('a', {
    staticClass: "primary--text ml-1 text-decoration-none",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goToCustomerInvoices.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("view")) + " ")])])]) : _vm._e()], 1), _vm.showAssignToField ? [_c('SearchUser', {
    attrs: {
      "value": _vm.order.assigned_to,
      "error-messages": _vm.order_saving_errors.assigned_to,
      "label": _vm.$translate('labels.assignedTo'),
      "dense": true,
      "outlined": "",
      "hide-details": "auto",
      "additional-params": {
        entity: _vm.current_entity_id,
        impersonification: false,
        is_active: true
      }
    },
    on: {
      "input": function input($event) {
        return _vm.updateAssignedTo($event);
      }
    }
  })] : _vm._e(), _vm.showComments ? [_c('v-textarea', {
    attrs: {
      "error-messages": _vm.order_saving_errors.comments,
      "label": _vm.$translate('labels.comments'),
      "placeholder": _vm.$translate('placeholders.comments'),
      "disabled": _vm.order.readonly,
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "rows": 2
    },
    model: {
      value: _vm.order.comments,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "comments", $$v);
      },
      expression: "order.comments"
    }
  })] : _vm._e(), _vm.showNotes ? [_c('v-textarea', {
    attrs: {
      "error-messages": _vm.order_saving_errors.notes,
      "label": _vm.$translate('labels.notes'),
      "placeholder": _vm.$translate('placeholders.notes'),
      "dense": "",
      "outlined": "",
      "rows": 2,
      "hide-details": "auto"
    },
    model: {
      value: _vm.order.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "notes", $$v);
      },
      expression: "order.notes"
    }
  })] : _vm._e(), !_vm.showComments || !_vm.showNotes ? _c('div', {
    staticClass: "enterprise-split-modal__expand-list"
  }, [!_vm.showComments && !_vm.order.readonly ? _c('button', {
    staticClass: "enterprise-split-expand",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.showComments = true;
      }
    }
  }, [_c('span', {
    staticClass: "enterprise-split-expand__icon-wrap"
  }, [_c('v-icon', {
    attrs: {
      "size": "14"
    }
  }, [_vm._v("mdi-plus")])], 1), _c('span', {
    staticClass: "enterprise-split-expand__label"
  }, [_vm._v(_vm._s(_vm.$translate("buttons.addComments")))])]) : _vm._e(), !_vm.showNotes ? _c('button', {
    staticClass: "enterprise-split-expand",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.showNotes = true;
      }
    }
  }, [_c('span', {
    staticClass: "enterprise-split-expand__icon-wrap"
  }, [_c('v-icon', {
    attrs: {
      "size": "14"
    }
  }, [_vm._v("mdi-plus")])], 1), _c('span', {
    staticClass: "enterprise-split-expand__label"
  }, [_vm._v(_vm._s(_vm.$translate("buttons.addNotes")))])]) : _vm._e()]) : _vm._e()], 2)])], 1)], 1)]), _c('section', {
    staticClass: "enterprise-split-modal__form order-edit-column d-flex flex-column"
  }, [_c('div', {
    staticClass: "stitch-modal stitch-modal--split"
  }, [_c('v-card', {
    staticClass: "stitch-modal__card",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('h5', {
    staticClass: "stitch-modal__title"
  }, [_c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-truck-outline")]), _c('span', [_vm._v(_vm._s(_vm.$translate("shippingSection")))])], 1), !_vm.buyer_id || _vm.buyer_id === 'new' ? _c('Placeholder', {
    attrs: {
      "title": _vm.$translate('selectCustomerForShipping'),
      "description": _vm.$translate('selectCustomerForShippingHint'),
      "min-height": 180,
      "width": 56,
      "no-padding": ""
    }
  }) : _c('div', {
    staticClass: "stitch-modal__stack"
  }, [_vm.buyer_id && _vm.buyer_id !== 'new' ? [_c('v-select', {
    attrs: {
      "value": _vm.order_type,
      "items": _vm.order_typechoices,
      "item-text": "text",
      "item-value": "value",
      "label": _vm.$translate('labels.deliveryMode'),
      "disabled": _vm.order.readonly,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": _vm.setOrderTypeAction
    }
  })] : _vm._e(), _vm.order_type !== 'no_delivery' ? _c('DateTime', {
    attrs: {
      "value": _vm.delivery_date,
      "label": _vm.$translate(_vm.order_type === 'pickup' ? 'labels.pickupDate' : 'labels.deliveryDate'),
      "error-messages": (_vm$order_saving_erro3 = _vm.order_saving_errors) === null || _vm$order_saving_erro3 === void 0 ? void 0 : _vm$order_saving_erro3.delivery_date,
      "only-date": true,
      "dense": "",
      "outlined": "",
      "min-date": null,
      "disabled": _vm.order.readonly,
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.updateDeliveryDate($event);
      }
    }
  }) : _vm._e(), _vm.order_type == 'shipping' && _vm.buyer_id ? [_c('div', {
    staticClass: "d-flex align-start"
  }, [((_vm$activeDeliverySit = _vm.activeDeliverySite) === null || _vm$activeDeliverySit === void 0 ? void 0 : _vm$activeDeliverySit.owner) == _vm.current_entity_id ? _c('v-btn', {
    staticClass: "mr-2 flex-shrink-0",
    staticStyle: {
      "min-width": "30px",
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "small": "",
      "title": _vm.$translate('editSite')
    },
    on: {
      "click": _vm.editSite
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-pencil")])], 1) : _vm._e(), _c('v-select', {
    key: Math.random(),
    staticClass: "flex-grow-1",
    attrs: {
      "value": _vm.deliverysite_id,
      "error-messages": _vm.order_saving_errors.deliverysite,
      "label": _vm.$translate('labels.deliverySite'),
      "disabled": _vm.deliverysites_loading,
      "items": _vm.deliverysiteschoices,
      "loading": _vm.deliverysites_loading,
      "dense": "",
      "outlined": "",
      "hide-details": "auto"
    },
    on: {
      "input": function input($event) {
        return _vm.setDeliverySiteIdAction($event);
      }
    }
  })], 1), _vm.deliverysiteschoices.length == 0 ? _c('div', {
    staticClass: "grey--text font-italic text-caption"
  }, [_vm._v(" " + _vm._s(_vm.$translate("noDeliverySite")) + " ")]) : _vm._e()] : _vm._e(), _vm.showDeliveryInstructions ? [_c('v-textarea', {
    attrs: {
      "error-messages": _vm.order_saving_errors.delivery_instructions,
      "label": _vm.$translate('labels.delivery_instructions'),
      "placeholder": _vm.$translate('placeholders.delivery_instructions'),
      "disabled": _vm.order.readonly,
      "dense": "",
      "outlined": "",
      "hide-details": "auto",
      "rows": 2
    },
    model: {
      value: _vm.order.delivery_instructions,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "delivery_instructions", $$v);
      },
      expression: "order.delivery_instructions"
    }
  }), _vm.showDeliveryInstructionsWarning ? _c('v-alert', {
    staticClass: "mb-0 enterprise-split-modal__alert-after-textarea",
    attrs: {
      "type": "info",
      "dense": "",
      "text": ""
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.$translate("delivery_update_warning")))])]) : _vm._e()] : _vm._e(), !_vm.showDeliveryInstructions && !_vm.order.readonly ? _c('button', {
    staticClass: "enterprise-split-expand",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.showDeliveryInstructions = true;
      }
    }
  }, [_c('span', {
    staticClass: "enterprise-split-expand__icon-wrap"
  }, [_c('v-icon', {
    attrs: {
      "size": "14"
    }
  }, [_vm._v("mdi-plus")])], 1), _c('span', {
    staticClass: "enterprise-split-expand__label"
  }, [_vm._v(_vm._s(_vm.$translate("buttons.addDeliveryInstructions")))])]) : _vm._e()], 2)], 1)], 1)], 1)])])])]), _c('template', {
    slot: "bottom"
  }, [_c('Button', {
    staticClass: "enterprise-split-modal__footer-cancel my-2 my-sm-4 w-100 w-sm-auto",
    attrs: {
      "text": _vm.$translate('buttons.cancel'),
      "ghost": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }), _c('Button', {
    key: JSON.stringify(_vm.order),
    staticClass: "enterprise-split-modal__footer-save my-2 my-sm-4 w-100 w-sm-auto ml-sm-4",
    attrs: {
      "text": _vm.saveText,
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.saveInformationClicked
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }